import React from 'react';
import Navbar from "../Components/Navbar";
import './productos.css';

const products = [
  {
    name: "Central de Control Inteligente",
    description: "La centralización perfecta de tu hogar. Controla luces, cámaras, sensores, y más desde un solo panel táctil con inteligencia artificial. Ideal para casas modernas que buscan eficiencia y seguridad.",
    image: "https://via.placeholder.com/400x250?text=Central+Control",
    whatsapp: "https://wa.me/1234567890?text=Hola%2C%20me%20interesa%20la%20Central%20de%20Control%20Inteligente"
  },
  {
    name: "Panel Solar SmartLink",
    description: "Panel solar inteligente con conectividad WiFi que optimiza el uso de energía según el clima y consumo. Visualiza el rendimiento en tiempo real desde tu celular.",
    image: "https://via.placeholder.com/400x250?text=Panel+Solar+Smart",
    whatsapp: "https://wa.me/1234567890?text=Hola%2C%20quiero%20información%20sobre%20el%20Panel%20Solar%20SmartLink"
  },
  {
    name: "Espejo Asistente Virtual",
    description: "Espejo con reconocimiento facial, asistente virtual, control de dispositivos y notificaciones diarias. Diseño elegante con funcionalidad increíble.",
    image: "https://via.placeholder.com/400x250?text=Espejo+Asistente",
    whatsapp: "https://wa.me/1234567890?text=Hola%2C%20me%20interesa%20el%20Espejo%20Asistente%20Virtual"
  },
  {
    name: "Sistema de Seguridad AI Vision",
    description: "Cámaras con inteligencia artificial que reconocen rostros, movimientos sospechosos y pueden diferenciar entre humanos, mascotas y objetos. Con alertas instantáneas a tu celular.",
    image: "https://via.placeholder.com/400x250?text=Seguridad+AI",
    whatsapp: "https://wa.me/1234567890?text=Hola%2C%20quiero%20saber%20más%20sobre%20el%20Sistema%20de%20Seguridad%20AI%20Vision"
  },
  {
    name: "Asistente de Voz Integrado con Casa",
    description: "Controla tu hogar con comandos naturales, integración con Alexa, Google y Siri. Automatiza escenas, rutinas y más desde tu voz.",
    image: "https://via.placeholder.com/400x250?text=Asistente+Voz",
    whatsapp: "https://wa.me/1234567890?text=Hola%2C%20estoy%20interesado%20en%20el%20Asistente%20de%20Voz%20Integrado"
  },
  {
    name: "Cortinas Automatizadas con Sensor Solar",
    description: "Abren y cierran automáticamente según la luz solar, también manejables por app o comandos de voz. Eficiencia energética + elegancia.",
    image: "https://via.placeholder.com/400x250?text=Cortinas+Smart",
    whatsapp: "https://wa.me/1234567890?text=Hola%2C%20quiero%20más%20info%20sobre%20las%20Cortinas%20Automatizadas"
  }
];

const Products = () => {
  return (
    <>
      <Navbar />
      <div className="products-wrapper">
        <h1 className="products-title">Catálogo de Productos Domóticos</h1>
        <div className="products-grid">
          {products.map((product, idx) => (
            <div key={idx} className="product-box">
              <img src={product.image} alt={product.name} className="product-img" />
              <div className="product-info">
                <h2>{product.name}</h2>
                <p>{product.description}</p>
                <a
                  href={product.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-button"
                >
                  Consultar por WhatsApp
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Products;
